import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import templateContent from "./client-solvency-request-modal.html";

import sampleRequestManager from "../../controllers/sampleRequestManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import { visitManager } from "../../_shark_jaws/managers/visitManager";
import ClientSolvencyRequest from "../../_shark_models/ClientSolvencyRequest";
import clientSolvencyRequestManager from "../../controllers/clientSolvencyRequestManager";

class ClientSolvencyRequestModalComponent extends Component {
	constructor () {
		super("clientSolvencyRequestModalComponent");
		this.addTemplate("", templateContent);
	}

	cancelEdits () {
		const { currClientSolvencyRequest } = Shark.get();

		if (currClientSolvencyRequest && (!currClientSolvencyRequest.isDirty() || confirm("Hai delle modifiche non salvate, vuoi davvero chiudere ed annullare le modifiche?"))) {
			currClientSolvencyRequest.restore();
			this.close();
		}
	}

	
	clientSolvencyRequestModalCancelBtn_clickHandler () {
		this.cancelEdits();
	}

	clientSolvencyRequestModalSaveBtn_clickHandler () {
		const { currClientSolvencyRequest } = Shark.get();

		if (currClientSolvencyRequest) {
			const errors = currClientSolvencyRequest.validate();

			if (errors.length > 0) {
				this.showErrors();
				alert("Attenzione, si sono verificati i seguenti errori:\n" + errors.join("\n"));
				return;
			}

			this.saveSampleRequest();
		}
	}

	close () {
		$("#clientSolvencyRequestModal").modal("hide");
	}
	
	async createNewClientSolvencyRequestBtn_clickHandler (event, data) {
		const referenceType = this.get("referenceType");
		let referenceItem;
		console.log(Object.values(data).length);

		if (Object.values(data).length > 0) {
			referenceItem = Utils.safp(Shark.$store[this.get("referenceList")], "guid", data.guid);
		}
		else {
			switch (this.get("referenceType")) {
				case "contact":
					referenceItem = Shark.$store?.editingClient;
					break;
				case "report":
					referenceItem = Shark.$store?.currVisit;
					break;
			}
		}

		if (referenceItem) {
			if (!referenceItem?.contact?.name && referenceItem.guid !== "") {
				await visitManager.getByGuid(referenceItem.guid)
				.then(getByGuidResponse => {
					console.log({getByGuidResponse});
					if (getByGuidResponse.data.length > 0) {
						referenceItem = getByGuidResponse.data[0];
						Shark.set({
							currVisit: referenceItem,
						});
					}
				});
			}

			let currClientSolvencyRequest;
			let clientSolvencyRequestReferenceContact;

			if (referenceType === "report") {
				// if (referenceItem.guid === "") {
				// 	if (confirm("Per poter richiedere una Campionatura devi salvare il Report, vuoi salvarlo ora?")) {
				// 		visitEditView.set("afterSaveDestination", "sampleRequest");
				// 		visitEditView.checkClientAndSaveVisit();
				// 	}
				// 	return;
				// }
				
				// clientSolvencyRequestReferenceContact = referenceItem.contact;
			}
			else {
				clientSolvencyRequestReferenceContact = referenceItem;
			}
			currClientSolvencyRequest = this.getNewSampleRequest(clientSolvencyRequestReferenceContact.guid);

			Shark.set({
				clientSolvencyRequestReferenceContact,
				currClientSolvencyRequest,
				__editClientSolvencyRequest: true,
			});

			Shark.render();
		}

		// if (visitActionsComponent.get("open")) {
		// 	visitActionsComponent.close();
		// }

		this.open();
	}

	// editSampleRequestBtn_clickHandler (event, data) {
	// 	const { sampleRequestList } = Shark.get();
	// 	const currClientSolvencyRequest = Utils.safp(sampleRequestList, "guid", data.guid);

	// 	if (currClientSolvencyRequest) {
	// 		Shark.set({
	// 			currClientSolvencyRequest,
	// 			__editSampleRequest: true,
	// 		});
	// 		Shark.render();
	// 		this.open();
	// 	}
	// }

	// getAddressFromContact (contact) {
	// 	let address = "";

	// 	if (contact.address) {
	// 		address += contact.name ? contact.name + "\n" : "";
	// 		address += contact.address ? contact.address + "\n" : "";
	// 		address += contact.zip ? contact.zip + " - " : "";
	// 		address += contact.city ? contact.city : "";
	// 		address += contact.province ? "(" + contact.province + ")": "";
	// 	}

	// 	return address;
	// }

	getNewSampleRequest (destGuid) {
		return new ClientSolvencyRequest({
			contactGuid: destGuid || "",
			status: ClientSolvencyRequest.STATUS_PENDING,
			userGuid: Shark.$store.currUser.guid,
		});
	}

	init () {
		this.addComponents([waitBoxComponent]);

							
		// Shark.set({
		// 	systemIndustrialIpmAquapermLine: systemIndustrialList.filter(item => item.line === "ipmAquapermLine"),
		// 	systemIndustrialIpmBasicLine: systemIndustrialList.filter(item => item.line === "ipmBasicLine"),
		// 	systemIndustrialIpmWallCoating: systemIndustrialList.filter(item => item.line === "ipmWallCoating"),
		// 	systemOutdoorDrivableList,
		// 	systemOutdoorPedestrianList,
		// });
	}

	open () {
		// let disableIndustrial = true;
		// let disableOutdoor = true;
		// const { currClientSolvencyRequest } = Shark.get();

		// if (currClientSolvencyRequest) {
		// 	if (Shark.$store.__editSampleRequest) {
		// 		disableIndustrial = !currClientSolvencyRequest.requestIndustrialSample;
		// 		disableOutdoor = !currClientSolvencyRequest.requestOutdoorSample;
		// 		document.querySelectorAll("#requestIndustrialSampleChk").forEach(item => item.disabled = false);
		// 		document.querySelectorAll("#requestOutdoorSampleChk").forEach(item => item.disabled = false);
		// 	}
		// 	else {
		// 		document.querySelectorAll("#requestIndustrialSampleChk").forEach(item => item.disabled = true);
		// 		document.querySelectorAll("#requestOutdoorSampleChk").forEach(item => item.disabled = true);
		// 	}
	
		// 	if (!currClientSolvencyRequest.requestIndustrialSample && currClientSolvencyRequest.requestOutdoorSample) {
		// 		document.querySelector("#nav-tab-outdoor").click();
		// 	}
		// }

		// document.querySelectorAll("#nav-industrial input:not(#requestIndustrialSampleChk)").forEach(item => item.disabled = disableIndustrial);
		// document.querySelectorAll("#nav-industrial textarea").forEach(item => item.disabled = disableIndustrial);

		// document.querySelectorAll("#nav-outdoor input:not(#requestOutdoorSampleChk)").forEach(item => item.disabled = disableOutdoor);
		// document.querySelectorAll("#nav-outdoor textarea").forEach(item => item.disabled = disableOutdoor);

		$("#clientSolvencyRequestModal").modal("show");
	}

	resetErrors () {
		document.querySelectorAll(".is-invalid").forEach(item => item.classList.remove("is-invalid"));
	}

	requestIndustrialSampleChk_changeHandler (event) {
		document.querySelectorAll("#nav-industrial input:not(#requestIndustrialSampleChk)").forEach(item => item.disabled = !event.target.checked);
		document.querySelectorAll("#nav-industrial textarea").forEach(item => item.disabled = !event.target.checked);
	}

	requestOutdoorSampleChk_changeHandler (event) {
		document.querySelectorAll("#nav-outdoor input:not(#requestOutdoorSampleChk)").forEach(item => item.disabled = !event.target.checked);
		document.querySelectorAll("#nav-outdoor textarea").forEach(item => item.disabled = !event.target.checked);
	}

	saveSampleRequest () {
		const { currClientSolvencyRequest } = Shark.get();

		if (currClientSolvencyRequest) {
			waitBoxComponent.open();

			clientSolvencyRequestManager.save(currClientSolvencyRequest)
			.then(() => {
				this.close();
				setTimeout(() => {
					waitBoxComponent.close();

					if (Shark.activePage.refreshClientSolvencyRequestList) {
						Shark.activePage.refreshClientSolvencyRequestList();
					}
				}, 200);
			});
		}
	}

	showErrors () {
		this.resetErrors();

		const { currClientSolvencyRequest } = Shark.get();

		for (let currProp in currClientSolvencyRequest.__errors) {
			if (currClientSolvencyRequest.__errors[currProp] === true) {
				document.querySelectorAll(`[data-sh-prop="${currProp}"]`).forEach(item => item.classList.add("is-invalid"));
			}
		}
	}

	showSampleRequestDetailsBtn_clickHandler (event, data) {
		const { sampleRequestList } = Shark.get();
		const currClientSolvencyRequest = Utils.safp(sampleRequestList, "guid", data.guid);

		if (currClientSolvencyRequest) {
			Shark.set({
				currClientSolvencyRequest,
				__editSampleRequest: false,
			});
			Shark.render();
			this.open();
		}
	}
}

const clientSolvencyRequestModalComponent = new ClientSolvencyRequestModalComponent();

Shark.registerComponent(clientSolvencyRequestModalComponent);

export default clientSolvencyRequestModalComponent;
